import { init } from '@plantquest/frontend/src/init'
let aws = {}
try {
  const awsContext = require.context('.', false, /aws-exports(\.js)?$/)
  const awsPath = awsContext
    .keys()
    .find(function (key) {
      return key === './aws-exports' || key === './aws-exports.js'
    })

  if (awsPath) {
    const awsModule = awsContext(awsPath)
    aws = awsModule.default || awsModule
  } else {
    console.warn('No aws-exports file found, continuing without Amplify config.')
  }
} catch (error) {
  console.warn('Unable to load aws-exports, continuing without Amplify config.', error)
}
//import td from '../../data/deploy/bausch/waterford.bausch/map_json_db/bl-wf01-ast-012.json' 
//import td from '../../data/deploy/bausch/waterford.bausch/map_json_db/bl-wf01-ast-013.2.json' 
//import td from '../../data/deploy/prd/map_json_db/pqd-pq01-ast-026.json' 
//import defaultTd from '../../data/deploy/prd/map_json_db/pqd-pq01-ast-025.json'
//import defaultTd from '../../data/deploy/jnj/biocork/map_json_db/jn-ry-ast-014.7.2.5.json'
import mixpanel from 'mixpanel-browser'
// Import Navvis Z-coordinate utility
import './utils/navvisZCoordinate'

function initializeMixpanel() {
  try {
    mixpanel.init('ffc5caf02d86aa22d5db7dfc2b128fff', {
      debug: true,
      api_host: 'https://api-eu.mixpanel.com',
      track_pageview: true,
      persistence: 'localStorage',
      secure_cookie: true,
      cookie_domain: '.plantquest.app',
    });
    console.log('Mixpanel initialized successfully-system-demo.');
  } catch (error) {
    console.error('Error initializing Mixpanel-system-demo.:', error);
  }
}


// Initialize td with a default value
//let td = defaultTd;
let td = {};
//pause and try to load the configured map if available


import model from '../model/model.json'
// lets load dotenv
import dotenv from 'dotenv'
//.env vars are up a level

// Load environment variables in order of precedence
dotenv.config({ path: '../.env.main' })
dotenv.config() // Load default .env if exists

// Client bundle only receives VUE_APP_* from webpack (see vue.config.js). DEPLOY_ENV is build-time only in Node.
const deployEnv =
  process.env.VUE_APP_DEPLOY_ENV || process.env.DEPLOY_ENV || 'dev'

// Load environment-specific variables (Node/dev only; production uses values baked at build time)
const envFile = `../../.env.${deployEnv}`
dotenv.config({ path: envFile })

console.log('Environment:', deployEnv)
console.log('Environment file:', envFile)
console.log('CloudFront Distribution:', process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION)

console.log('D02', deployEnv, process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION)

console.log('process.env.MAP_JSON_FILE', process.env.MAP_JSON_FILE)



td.assets = []

document.title = process.env.VUE_APP_TITLE || 'PlantQuest';

let env_file = `.env.${deployEnv}`
dotenv.config({ path: env_file })
console.log('env_file', env_file)

console.log('map_height', process.env.VUE_APP_MAP_HEIGHT || process.env.MAP_HEIGHT)

const info = {
  node_env: process.env.NODE_ENV,
  auth_mode: 'seneca',
  VUE_APP_CLOUDFRONT_DISTRIBUTION: process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION,
  app: {
    system: 'demo',
    name: 'admwa01',
    version: '0.5.0',
    note: process.env.VUE_APP_NOTE || "",
  },
  PqsFrontend: init.info,
}
console.log('!!!td', td)
td.rooms = []

const hostname = window.location.hostname;
const baseUrl = hostname === 'localhost' 
? `http://${hostname}:9204` 
: `https://${hostname}`;


// Field lists are defined once in @plantquest/frontend/src/config/fieldConfig.js.
// They fall back to defaults mirroring the backend asset_fieldmap.ts, and can
// be overridden per-site via VUE_APP_ASSET_FIELDS / VUE_APP_ROOM_FIELDS in .env.
import { ASSET_QUERY_FIELDS as assetFields, ROOM_QUERY_FIELDS as roomFields } from '@plantquest/frontend/src/config/fieldConfig'

// Load both rooms and assets from Seneca endpoints (replacing direct DynamoDB calls)
Promise.all([
  // Get rooms (assets with atype = 'Room/Area')
  fetch(baseUrl+'/api/private/msg01', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "cmd": "list",
      "q": {
        "atype": "Room/Area",
        "building$": { "$ne": null },
        "map$": { "$ne": null },
        "level$": { "$ne": null },
        "poly$": { "$exists": true, "$ne": null },
        "tag$": { "$ne": null },
        "fields$": roomFields
      },
      "qent": {
        "entity$": "-/pqs/asset"
      },
      "sys": "entity",
      "base": "pqs",
      "name": "asset"
    })
  }).then(response => {
    console.log('Rooms response status:', response.status);
    console.log('Rooms response headers:', response.headers);
    return response.json();
  }).then(data => {
    console.log('Rooms response data:', data);
    return data;
  }).catch(error => {
    console.error('Rooms fetch error:', error);
    return { data: [] };
  }),
  
  // Get all assets
  fetch(baseUrl+'/api/private/msg01', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "cmd": "list",
      "tag$": { "$ne": null },         // Exclude assets where tag is null
      "q": {
        "fields$": assetFields
      },
      "qent": {
        "entity$": "-/pqs/asset"
      },
      "sys": "entity",
      "base": "pqs",
      "name": "asset"
    })
  }).then(response => {
    console.log('Assets response status:', response.status);
    return response.json();
  }).then(data => {
    console.log('Assets response data:', data);
    return data;
  }).catch(error => {
    console.error('Assets fetch error:', error);
    return { data: [] };
  })
])
  .then(([roomResponse, assetResponse]) => {
    console.log('Full roomResponse:', roomResponse);
    console.log('Full assetResponse:', assetResponse);
    
    // Try different possible response structures
    let allRooms = roomResponse.data || roomResponse || [];
    td.assets = assetResponse.data || assetResponse || [];
    td.levels = []
    
    // Filter rooms to only include those with valid polygon data
    td.rooms = allRooms.filter(room => {
      const hasValidPoly = room.poly && 
                          Array.isArray(room.poly) && 
                          room.poly.length > 0 &&
                          room.poly.some(point => Array.isArray(point) && point.length >= 2);
      
      if (!hasValidPoly) {
        console.log(`Filtering out room without valid poly: ${room.tag || room.id}`, room.poly);
      }
      
      return hasValidPoly;
    });
    
    console.log('td.rooms (filtered):', td.rooms);
    console.log('td.assets', td.assets);
    console.log('Loaded rooms from Seneca:', td.rooms.length, 'rooms (filtered from', allRooms.length, 'total)');
    console.log('Loaded assets from Seneca:', td.assets.length, 'assets');

    // Debug: Check what level data we have
    console.log('Sample asset data:', td.assets.slice(0, 2));
    console.log('Sample room data:', td.rooms.slice(0, 2));

    // Generate deps dynamically after rooms and assets are loaded
    td.deps = generateDeps(
      td.assets || [], 
      td.rooms, 
      td.maps || [], 
      td.buildings || [], 
      td.levels || []
    );
    
    console.log('Generated deps:', td.deps);
    
    // Debug: Check map~building~level relationships specifically
    if (td.deps.pc && td.deps.pc['map~building~level']) {
      console.log('map~building~level relationships:', Object.keys(td.deps.pc['map~building~level']));
      console.log('Sample map~building~level data:', Object.keys(td.deps.pc['map~building~level']).slice(0, 5).map(key => ({
        key,
        rooms: td.deps.pc['map~building~level'][key]?.room || []
      })));
    } else {
      console.log('WARNING: No map~building~level relationships found in deps.pc');
    }
    
    // Extract and populate levels, maps, and buildings from deps
    td.levels = extractLevelsFromDeps(td.deps);
    console.log('Extracted levels:', td.levels);
    
    td.maps = extractMapsFromAssets(td.assets);
    console.log('Extracted maps:', td.maps);

    td.buildings = extractBuildingsFromDeps(td.deps);
    td.buildings.push('Dynamic Test Building');
    console.log('Extracted buildings:', td.buildings);

    // search data.rooms for 'PQ ROOM 2 21'
    const room = td.rooms.find(room => room.room === 'PQ ROOM 2 21');
    console.log('Test room:', room);

    // Initialize the PlantQuest frontend after deps are generated
    initPlantQuest();
  })
  .catch(error => {
    console.error('Error fetching data:', error);
    td.rooms = [];
    td.assets = [];
    
    // Generate deps even if data loading fails
    td.deps = generateDeps(
      td.assets || [], 
      td.rooms, 
      td.maps || [], 
      td.buildings || [], 
      td.levels || []
    );
    
    console.log('Generated deps (fallback):', td.deps);
    
    // Extract levels, maps, and buildings from deps
    td.levels = extractLevelsFromDeps(td.deps);
    console.log('Extracted levels (fallback):', td.levels);
    
    td.maps = extractMapsFromAssets(td.assets);
    console.log('Extracted maps (fallback):', td.maps);
    
    td.buildings = extractBuildingsFromDeps(td.deps);
    console.log('Extracted buildings (fallback):', td.buildings);
    
    // Initialize the PlantQuest frontend
    initPlantQuest();
  });
//jn-rsky-m01-004

let custom = {
  navvis_map_data : [
    {
      "map_1": {
        "bounds": [4596,5349,4596,5584,4339,5584,4339,5347],
        "floor_z": 44.6,
        "ceiling_z": 51.9,
        "map" : 1
      },

      "map_1_1": {
        "bounds": [4864,5423,4864,5577,4729,5577,4729,5496,4668,5496,4668,5423],
        "floor_z": 44.7,
        "ceiling_z": 47.9,
        "map" : 1
      },
      
      
      
    }
  ],
  levelNames : [
    'Ground Floor', // Map 1
    'Level 1',      // Map 2
    'Level 2',      // Map 3
  ],
  map_dict: {
    'bl-wf01-m01-009': 'Ground Floor',
    'bl-wf01-m02-009': 'First Floor',
    'bl-wf01-m03-009': 'Second Floor',
  },
  filters: [
     
      //{ name: 'building', title: 'Building', show: true, value: '', items: [] },

    // TODO: spelling!
    // { name:'dicipline1', title:'Discipline', show:true, value:'', items:[] },

    // TODO: custom?
    // { name:'systemtype', title:'System Type', show:true, value:'', items:[] },
    { name: 'custom4', title: 'Building', show: true, value: '', items: [] },
    { name: 'level', title: 'Level', show: true, value: '', items: [] },
    //{ name: 'custom9', title: 'Parent Description', show: true, value: '', items: [] },
    
    //{ name: 'data7', title: 'Mobile / Fixed Asset', show: true, value: '', items: [] },
   { name: 'filtertop', title: 'System Type', show: true, value: '', items: [] },
    { name: 'filterside', title: 'System', show: true, value: '', items: [] },

    { name: 'atype', title: 'Asset Type', show: true, value: '', items: [] },

    // { name:'system', title:'System', show:true, value:'', items:[] },
    // { name:'subsys', title:'Sub-System', show:true, value:'', items:[] },

    // TODO: manfacturer
    // { name:'custom2', title:'Manufacturer', show:true, value:'', items:[] },

   /* {
      name: 'drawing1',
      title: 'Drawing No.',
      show: true,
      value: '',
      items: [],
    },*/

    // TODO: model
    // { name:'custom8', title:'Model', show:true, value:'', items:[] },
  ],
  // Room layer config is set via VUE_APP_ROOM_LAYER_CONFIG in the env file (see below).
  // pqs-frontend uses that env var; we also expose it as custom.roomLayerConfig for init().

  // custom datasets depending on a plant
  datasets: {
    tag: 'tag',
    atype: 'atype',
    description: 'description',
    dicipline1: 'discipline',
    room: 'room',
    level: 'level',
    custom4: 'custom4',
    model: 'model',
    manufacturer: 'manufacturer',
    system: 'system',
    subsys: 'subsys',
    serial: 'serial',
    drawing1: 'drawing1',
    drawing2: 'drawing2',
    building: 'building',
    custom12: 'room_alias',
    data7: 'data7',
    filtertop: 'system_top',
  },

  mixpanel: {
    project_token: process.env.VUE_APP_MIXPANEL_TOKEN || '[REDACTED]',
    //project_token: 'bbdbc44055174019937323fc6ed6f353',
  },
  
  mixpanel_front_events: {
    sign_in: {},
    PQView_search: {},
    Go_filter: {},
    polygon_selection: {},
    work_pack_save: {},
    work_pack_load: {},
    asset_update: {},
    new_user: {},
    show_tags: {},
    cluster_tags: {},
    path_details: {},
    navvis_iframe_clicked:{},
  },
}

// Optional: override/merge custom config from env (DEPLOY_ENV points to .env.<deployEnv>)
//   VUE_APP_CUSTOM_CONFIG='{"levelNames":["Ground Floor"],"map_dict":{"jn-m01":"Ground Floor"}}'
// Filters (dropdowns): set VUE_APP_FILTERS_CONFIG in the same env file, e.g.:
//   VUE_APP_FILTERS_CONFIG='[{"name":"custom4","title":"Building","show":true,"value":"","items":[]},{"name":"level","title":"Level","show":true,"value":"","items":[]},{"name":"atype","title":"Asset Type","show":true,"value":"","items":[]}]'
// Room layers (used by pqs-frontend): set VUE_APP_ROOM_LAYER_CONFIG in the same env file, e.g.:
//   VUE_APP_ROOM_LAYER_CONFIG='{"data8":{"label":"Filtered Mask","color":"#FFD700"},"data9":{"label":"Ear Defenders","color":"#808080"},"data10":{"label":"Additional Hi-Vis","color":"#0077CC"}}'
// Default format: { data8: { label: 'Welfare Rooms', color: '#FFD700' }, data9: { label: 'Plant Room', color: '#808080' }, ... }
function mergeCustomFromEnv(customObj, envJson) {
  if (!envJson || typeof envJson !== 'string') return
  try {
    const parsed = JSON.parse(envJson)
    if (!parsed || typeof parsed !== 'object') return
    Object.keys(parsed).forEach(function (key) {
      const envVal = parsed[key]
      if (envVal !== null && typeof envVal === 'object' && !Array.isArray(envVal) &&
          customObj[key] !== null && typeof customObj[key] === 'object' && !Array.isArray(customObj[key])) {
        customObj[key] = Object.assign({}, customObj[key], envVal)
      } else {
        customObj[key] = envVal
      }
    })
    console.log('Merged custom config from VUE_APP_CUSTOM_CONFIG')
  } catch (e) {
    console.warn('Invalid VUE_APP_CUSTOM_CONFIG JSON, using defaults:', e.message)
  }
}
mergeCustomFromEnv(custom, process.env.VUE_APP_CUSTOM_CONFIG)

// Override filters from dedicated env var (takes precedence over filters in VUE_APP_CUSTOM_CONFIG)
try {
  var filtersEnv = process.env.VUE_APP_FILTERS_CONFIG
  if (filtersEnv && typeof filtersEnv === 'string') {
    var parsedFilters = JSON.parse(filtersEnv)
    if (Array.isArray(parsedFilters)) {
      custom.filters = parsedFilters
      console.log('Filters set from VUE_APP_FILTERS_CONFIG:', custom.filters.length, 'filters')
    }
  }
} catch (e) {
  console.warn('Invalid VUE_APP_FILTERS_CONFIG JSON:', e.message)
}

// Expose room layer config for pqs-frontend (also reads VUE_APP_ROOM_LAYER_CONFIG at build time)
try {
  var roomLayerEnv = process.env.VUE_APP_ROOM_LAYER_CONFIG
  custom.roomLayerConfig = (roomLayerEnv && typeof roomLayerEnv === 'string')
    ? JSON.parse(roomLayerEnv)
    : null
} catch (e) {
  console.warn('Invalid VUE_APP_ROOM_LAYER_CONFIG JSON:', e.message)
  custom.roomLayerConfig = null
}

// False unless testing locally
let isStaticAssetUpload = process.env.VUE_APP_STATIC_ASSET_UPLOAD ?
  process.env.VUE_APP_STATIC_ASSET_UPLOAD.toLowerCase() === 'true' : false

isStaticAssetUpload = false

console.log('isStaticAssetUpload: ', isStaticAssetUpload)
let MAP_HEIGHT = process.env.MAP_HEIGHT
var MAP_WIDTH = process.env.MAP_WIDTH


// Dynamic deps generation functions
function generateDeps(assets, rooms, maps, buildings, levels) {
  const deps = {
    cp: {},
    pc: {},
  };

  // Dataset mappings (from assets.js)
  const datasets = {
    'custom19': 'drawing1',
    'custom20': 'drawing2', 
    'custom7': 'position',
    'room': 'room',
    'custom5': 'level',
    'custom4': 'building',
    'custom3': 'model',
    'custom16': 'serial',
    'custom2': 'manufacturer',
    'dicipline1': 'discipline',
    'custom17': 'system',
    'custom18': 'subsys',
    'map': 'map',  // Ensure map field is properly mapped
  };

  const ROOM_ATYPE = {
    'asrs': 1, 'building': 1, 'car park': 1, 'contractor compound': 1,
    'corridor': 1, 'external area': 1, 'laydown area': 1, 'path': 1,
    'plant': 1, 'road': 1, 'roof area': 1, 'room': 1, 'storage': 1,
    'tank farm': 1, 'void': 1, 'room/area': 1,
  };

  // Relationship definitions
  const relate = [
    {pc:true, p:'room',c:'asset',exclude:(row)=>row.room$},
    {pc:true, p:'map',c:'building'},
    {pc:true, p:'building',c:'level'},
    {pc:true, p:'building',c:'map'},
    {pc:true, p:'map~building',c:'level'},
    {pc:true, p:'map~building~level',c:'room',include:(row)=>row.room$},
    {pc:true, p:'building~level',c:'map'},
    {pc:true, p:'map~level',c:'level', include:(row)=>row.map},
    {cp:true, p:'map~building~level',c:'room'},
    {cp:true, p:'room',c:'asset', exclude:(row)=>row.room$},
  ];

  // Convert assets array back to objects and apply transformations
  let assetObjects = [];
  if (assets && assets.length > 0) {
    // Check if assets is already an array of objects (from API)
    if (typeof assets[0] === 'object' && !Array.isArray(assets[0])) {
      // Assets are already objects, use them directly
      assetObjects = assets.map(item => {
        // Ensure all values are strings and trimmed
        const processedItem = {};
        for (let key in item) {
          const value = item[key];
          // Convert null/undefined to empty string instead of string "null"/"undefined"
          if (value === null || value === undefined) {
            processedItem[key] = '';
          } else {
            const strValue = ('' + value).trim();
            // Also convert string "null", "undefined", "NaN" to empty string
            if (strValue === 'null' || strValue === 'undefined' || strValue === 'NaN') {
              processedItem[key] = '';
            } else {
              processedItem[key] = strValue;
            }
          }
        }
        return processedItem;
      });
    } else if (Array.isArray(assets[0])) {
      // Assets are in CSV-like format [headers, ...rows]
      const [headers, ...assetRows] = assets;
      if (Array.isArray(headers)) {
        assetObjects = assetRows.map(row => {
          const item = {};
          headers.forEach((header, index) => {
            const value = row[index];
            // Convert null/undefined to empty string instead of string "null"/"undefined"
            if (value === null || value === undefined) {
              item[header] = '';
            } else {
              const strValue = ('' + value).trim();
              // Also convert string "null", "undefined", "NaN" to empty string
              if (strValue === 'null' || strValue === 'undefined' || strValue === 'NaN') {
                item[header] = '';
              } else {
                item[header] = strValue;
              }
            }
          });
          return item;
        });
      }
    }
    
    // Apply dataset transformations and processing to all assetObjects
    assetObjects = assetObjects.map(item => {

      // Apply dataset transformations (CRITICAL!)
      for(let field in datasets) {
        if (item[field] !== undefined) {
          item[datasets[field]] = (''+item[field]).trim();
        }
      }

      // Ensure map field has a valid value to prevent "Mnull" issue
      
      if (!item.map) {
        // Only use numeric map values, don't create building-based maps
        // Try to extract numeric map from level if it's in M# format
        if (item.level && /^M\d+$/.test(item.level)) {
          item.map = item.level.substring(1); // Extract number from M1, M2, etc.
        } else if (item.level && /^\d+$/.test(item.level)) {
          item.map = item.level; // Use level if it's already numeric
        } else {
          item.map = '4'; // Default to map 1 instead of building-based names
        }
        console.warn(`Asset ${item.tag || item.id} missing map data, using: ${item.map}`);
      }

      // When an asset has no level, use its map value as the level so that
      // the map~level dep keys are unique per map and filterAssets works correctly.
      if ((!item.level || item.level === '' || item.level === 'null') && item.map) {
        item.level = item.map;
      }

      // Set ID correctly (CRITICAL!)
      item.id = item.data4 || item.id; // Use data4 if available, fallback to existing id
      
      // Convert coordinates
      item['xco'] = item['xco'] ? +item['xco'] : 0;
      item['yco'] = item['yco'] ? +item['yco'] : 0;
      item['zco'] = item['zco'] ? +item['zco'] : 0;

      // Process polygons for room types
      if(ROOM_ATYPE[item.atype?.toLowerCase()] =='room/area') {
        item = processPolygon(item);
      }
     

      item.$preset = true;
      return item;
    });
  }

  // Combine all data sources
  const allRows = [...assetObjects, ...(rooms || [])];
  
  console.log('Building relationships from', allRows.length, 'rows');
  console.log('Sample rows with room$ property:', allRows.filter(r => r.room$).slice(0, 3));
  console.log('Sample regular rows:', allRows.filter(r => !r.room$).slice(0, 3));

  // Build relationships (same as before)
  allRows.forEach(row => {
    relate.forEach(r => {
      // Build Child-to-Parent
      if(r.cp && (!r.exclude || !r.exclude(row)) && (!r.include || r.include(row))) {
        const pv = makeParentVal(r, row);
        deps.cp[r.c] = deps.cp[r.c] || {};
        deps.cp[r.c][row[r.c]] = pv;
      }

      // Build Parent-to-Child
      if(r.pc && (!r.exclude || !r.exclude(row)) && (!r.include || r.include(row))) {
        const pk = makeParentKey(r, row);
        
        // Debug specific relationship
        if (r.p === 'map~building~level') {
          console.log('Building map~building~level relationship:', {
            parentKey: pk,
            child: r.c,
            childId: makeChildId(r, row),
            row: { map: row.map, building: row.building, level: row.level, room: row.room, hasRoom$: !!row.room$ }
          });
        }
        
        deps.pc[r.p] = deps.pc[r.p] || {};
        deps.pc[r.p][pk] = deps.pc[r.p][pk] || {};
        deps.pc[r.p][pk][r.c] = deps.pc[r.p][pk][r.c] || [];
        
        const cid = makeChildId(r, row);
        insertChild(deps.pc[r.p][pk][r.c], cid);
      }
    });
  });

  return deps;
}

// Add polygon processing function
function processPolygon(item) {
  let poly = [];
  
  // Use existing polygon data from API if available
  if (item.poly && Array.isArray(item.poly) && item.poly.length > 0) {
    poly = item.poly;
    console.log('Using existing polygon data for', item.tag || item.name, ':', poly.length, 'points');
  } else if (item.data2) {
    // Fallback to parsing data2 only if poly doesn't exist
    const MAP_HEIGHT = parseInt(process.env.VUE_APP_MAP_HEIGHT) || 6144;
    let coords = item.data2.split(/\s*-\s*/).filter(c=>''!=c&&'#N/A'!=c);
    
    if(coords.length > 0) {
      for(var cI = 0; cI < coords.length-1; cI+=2) {
        if(''!=coords[cI]&&''!=coords[cI+1]) {
          poly.push([MAP_HEIGHT-Math.round(coords[cI+1]),Math.round(coords[cI])]);
        }
      }
    }
    console.log('Parsed polygon data from data2 for', item.tag || item.name, ':', poly.length, 'points');
  } else {
    console.warning('No polygon data found for', item.tag || item.name);
  }
  
  if(poly.length > 0) {
    item.room$ = {
      id: item.data4 || item.id,
      name: item.tag || item.name,
      room: item.room,
      xco: item.xco,
      yco: item.yco,
      zco: item.zco,
      map: item.map,
      area: item.data5 || item.area,
      level: item.level,
      building: item.building,
      desc: item.description || item.desc,
      poly: poly,
      level_id: item.data6,
      showlabel: item.data5 || item.area,
      row: item.row,
    };
  }
  return item;
}

// Helper functions
function makeParentKey(relate, row) {
  return relate.p.split(/~/g).map(pn => row[pn] || '').join('~');
}

function makeParentVal(relate, row) {
  return relate.p.split(/~/g).reduce((a, pn) => (a[pn] = row[pn] || '', a), {});
}

function makeChildId(relate, row) {
  return row[relate.c];
}

function insertChild(arr, child) {
  if (!child) return;
  
  for(let i = 0; i < arr.length; i++) {
    if(('~'+arr[i]) === ('~'+child)) {
      return;
    }
    else if(('~'+arr[i]) > ('~'+child)) {
      arr.splice(i, 0, child);
      return;
    }
  }
  arr.push(child);
}

// Helper function to extract buildings from deps
function extractBuildingsFromDeps(deps) {
  const buildings = new Set();
  
  // Function to validate if a building name is valid
  const isValidBuildingName = (buildingName) => {
    if (!buildingName || typeof buildingName !== 'string') return false;
    const trimmed = buildingName.trim();
    
    // Filter out invalid values
    const invalidValues = [
      '', 'null', 'undefined', 'custom4val', 'custom4', 
      'NaN', 'false', 'true', '0', 'N/A', '#N/A', 
      'none', 'None', 'NONE', 'TBD', 'tbd'
    ];
    
    // Check if it's in the invalid list (case insensitive)
    if (invalidValues.some(invalid => invalid.toLowerCase() === trimmed.toLowerCase())) {
      return false;
    }
    
    // Filter out values that look like field names (contain 'custom' or 'data')
    if (trimmed.toLowerCase().includes('custom') || trimmed.toLowerCase().includes('data')) {
      return false;
    }
    
    // Must be at least 2 characters and not just numbers
    if (trimmed.length < 2 || /^\d+$/.test(trimmed)) {
      return false;
    }
    
    return true;
  };
  
  // Extract from parent-child relationships
  if (deps.pc && deps.pc.building) {
    // Get all building keys from deps.pc.building
    Object.keys(deps.pc.building).forEach(buildingName => {
      if (isValidBuildingName(buildingName)) {
        console.log('Adding building:', buildingName);
        //buildings.add(buildingName.trim());
      }
    });
  }
  
  // Extract from map~building relationships if they exist
  if (deps.pc && deps.pc['map~building']) {
    Object.keys(deps.pc['map~building']).forEach(mapBuilding => {
      // mapBuilding format is "map~building"
      const parts = mapBuilding.split('~');
      if (parts.length >= 2 && isValidBuildingName(parts[1])) {
        buildings.add(parts[1].trim());
      }
    });
  }
  
  // Extract from child-parent relationships
  if (deps.cp && deps.cp.building) {
    Object.keys(deps.cp.building).forEach(buildingName => {
      if (isValidBuildingName(buildingName)) {
        buildings.add(buildingName.trim());
      }
    });
  }
  
  // Convert Set to sorted array
  return Array.from(buildings).sort();
}

// Helper function to extract levels from deps
function extractLevelsFromDeps(deps) {
  const levels = new Set();
  
  // Valid level pattern: M followed by a number (M1, M2, M3, etc.)
  const isValidLevel = (levelName) => {
    if (!levelName || typeof levelName !== 'string') return false;
    const trimmed = levelName.trim();
    // Match M followed by one or more digits
    return /^M\d+$/.test(trimmed);
  };
  
  if (deps.pc && deps.pc.level) {
    Object.keys(deps.pc.level).forEach(levelName => {
      if (isValidLevel(levelName)) {
        levels.add(levelName.trim());
      }
    });
  }
  
  // Extract from composite keys like "building~level" or "map~building~level"
  Object.keys(deps.pc || {}).forEach(parentKey => {
    if (parentKey.includes('level')) {
      Object.keys(deps.pc[parentKey]).forEach(compositeKey => {
        const parts = compositeKey.split('~');
        // Find the level part (usually the last part in building~level or map~building~level)
        const levelIndex = parentKey.split('~').indexOf('level');
        if (levelIndex >= 0 && parts[levelIndex]) {
          const levelName = parts[levelIndex].trim();
          if (isValidLevel(levelName)) {
            levels.add(levelName);
          }
        }
      });
    }
  });
  
  // Sort levels numerically (M1, M2, M3, etc.)
  return Array.from(levels).sort((a, b) => {
    const numA = parseInt(a.substring(1));
    const numB = parseInt(b.substring(1));
    return numA - numB;
  });
}

// Helper function to extract maps directly from assets
function extractMapsFromAssets(assets) {
  const maps = new Set();
  
  // Function to validate if a map value is valid
  const isValidMapValue = (mapValue) => {
    if (mapValue === null || mapValue === undefined) return false;
    
    const mapStr = String(mapValue).trim();
    
    // Filter out invalid values
    const invalidValues = [
      '', 'null', 'undefined', 'Mnull', 'null~', '~null',
      'NaN', 'false', 'true', 'N/A', '#N/A', 
      'none', 'None', 'NONE', 'TBD', 'tbd'
    ];
    
    // Check if it's in the invalid list (case insensitive)
    if (invalidValues.some(invalid => invalid.toLowerCase() === mapStr.toLowerCase())) {
      return false;
    }
    
    // Filter out values that contain 'null'
    if (mapStr.toLowerCase().includes('null')) {
      return false;
    }
    
    // Must be at least 1 character
    if (mapStr.length < 1) {
      return false;
    }
    
    // Only accept numeric map values (1, 2, 3, etc.) or M-prefixed levels (M1, M2, M3, etc.)
    // Reject building names and other non-map identifiers
    const isNumeric = /^\d+$/.test(mapStr);
    const isMLevel = /^M\d+$/.test(mapStr);
    
    // Reject if it looks like a building name (contains letters but not in M# format)
    const hasLetters = /[a-zA-Z]/.test(mapStr);
    const isBuildingName = hasLetters && !isMLevel;
    
    if (isBuildingName) {
      return false;
    }
    
    return isNumeric || isMLevel;
  };
  
  // Extract maps directly from asset data
  if (assets && Array.isArray(assets)) {
    console.log(`Processing ${assets.length} assets for map extraction`);
    let validMaps = 0;
    let invalidMaps = 0;
    
    assets.forEach((asset, index) => {
      if (asset && typeof asset === 'object') {
        // Debug: Show all map values being processed
        if (index < 10) {
          console.log(`Asset ${index}: ${asset.tag || asset.id} -> map: "${asset.map}" (type: ${typeof asset.map})`);
        }
        
        if (isValidMapValue(asset.map)) {
          maps.add(String(asset.map).trim());
          validMaps++;
          
          // Debug: Show first few valid maps
          if (validMaps <= 5) {
            console.log(`✅ VALID MAP: Asset ${index}: ${asset.tag || asset.id} -> map: "${asset.map}"`);
          }
        } else {
          invalidMaps++;
          // Debug: Show first few invalid maps
          if (invalidMaps <= 10) {
            console.log(`❌ INVALID MAP: Asset ${index}: ${asset.tag || asset.id} -> map: "${asset.map}"`);
          }
        }
      }
    });
    
    console.log(`Map extraction: ${validMaps} valid, ${invalidMaps} invalid, ${maps.size} unique maps found`);
    console.log('All extracted maps:', Array.from(maps));
    
    // Debug: Show what types of maps we found
    const mapArray = Array.from(maps);
    const numericMaps = mapArray.filter(map => /^\d+$/.test(map));
    const mLevelMaps = mapArray.filter(map => /^M\d+$/.test(map));
    const otherMaps = mapArray.filter(map => !/^\d+$/.test(map) && !/^M\d+$/.test(map));
    
    console.log('Numeric maps:', numericMaps);
    console.log('M-level maps:', mLevelMaps);
    console.log('Other maps (should be empty):', otherMaps);
  }
  
  // Sort maps properly - handle both numeric maps and M-prefixed levels
  const mapArray = Array.from(maps);
  
  return mapArray.sort((a, b) => {
    // Handle numeric maps (1, 2, 3, etc.)
    const aIsNumeric = /^\d+$/.test(a);
    const bIsNumeric = /^\d+$/.test(b);
    
    if (aIsNumeric && bIsNumeric) {
      return parseInt(a) - parseInt(b);
    }
    
    // Handle M-prefixed levels (M1, M2, M3, etc.)
    const aIsMLevel = /^M\d+$/.test(a);
    const bIsMLevel = /^M\d+$/.test(b);
    
    if (aIsMLevel && bIsMLevel) {
      const aNum = parseInt(a.substring(1));
      const bNum = parseInt(b.substring(1));
      return aNum - bNum;
    }
    
    // Mixed types: put numeric maps first, then M-levels
    if (aIsNumeric && bIsMLevel) return -1;
    if (aIsMLevel && bIsNumeric) return 1;
    
    // Fallback to alphabetical
    return a.localeCompare(b);
  });
}


console.log('APP: demwa01', 'map:009', 'data:009a', info, model, td, isStaticAssetUpload)

//bl-wf01-m01-001
function initPlantQuest() {
  console.log('APP: demwa01', 'map:009', 'data:009a', info, model, td, isStaticAssetUpload);

  init({
    info,
    aws,
    custom,
    td,
    model,
    VUE_APP_CLOUDFRONT_DISTRIBUTION: process.env.VUE_APP_CLOUDFRONT_DISTRIBUTION || "",
    upload: isStaticAssetUpload,
    
    map: {
      prefix: process.env.VUE_APP_MAP_PREFIX,
      suffix: process.env.VUE_APP_MAP_SUFFIX,
      width: parseInt(process.env.VUE_APP_MAP_WIDTH),
      height: parseInt(process.env.VUE_APP_MAP_HEIGHT),
      minZoom: parseInt(process.env.VUE_APP_MAP_MIN_ZOOM),
      maxZoom: parseInt(process.env.VUE_APP_MAP_MAX_ZOOM),
      zoom: parseInt(process.env.VUE_APP_MAP_ZOOM)
    },
    levelNames: {
      test: 'Level 1',
    },
    kinde: {
      client_id: process.env.VUE_APP_KINDE_CLIENT_ID,
      domain: process.env.VUE_APP_KINDE_DOMAIN
    },
    seneca: {
      endpoint: (msg) => {
        let isPublic = ('web' === msg.aim &&
                        ('auth' === msg.on || 'user' === msg.signin))

        let prepath = '/api'
        let suffix = prepath + (isPublic ? '/public/auth' : '/private/' + (msg.on || 'msg01'))
        
        let url = document.location.origin + suffix
      
        console.log('ENDPOINT', isPublic, url, msg)
        
        return url
      }
    },
  });
}